import ContractReprint from './ContractReprint.vue';

export default ContractReprint;
